import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bayernwerk-storungen',
  templateUrl: './bayernwerk-storungen.component.html',
  styleUrls: ['./bayernwerk-storungen.component.scss'],
})
export class BayernwerkStorungenComponent {
  @Input() url!: string;
  @Input() isIE11 = false;

  constructor(private _router: Router) {}

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }
}
